import { Directive } from '@angular/core';

@Directive({
  selector: '[wlKeyboardNavigationTarget]',
  standalone: true,
})
export class KeyboardNavigationTargetDirective {}
